import React from 'react';
import PropTypes from 'prop-types';
import hoistNonReactStatics from 'hoist-non-react-statics';
import { getDisplayName } from '@bingads-webui-react/hoc-utils';
import { useNeedsAttention } from './use-needs-attention';

export const withAttentionBeaconRender = (WrappedComponent) => {
  const HOC = ({ attentionBeaconProps: attentionBeaconPropsFromProps, render, ...restProps }) => {
    const [needsAttention, attentionBeaconProps] = useNeedsAttention(attentionBeaconPropsFromProps);

    return (
      <WrappedComponent
        {...restProps}
        attentionBeaconProps={attentionBeaconProps}
        // {...WrappedComponent.isAttentionBeaconConsumer ? { attentionBeaconProps } : {}}
      >
        {render({ needsAttention })}
      </WrappedComponent>
    );
  };

  HOC.propTypes = {
    attentionBeaconProps: PropTypes.shape({
      needsAttention: PropTypes.bool,
    }),
    render: PropTypes.func.isRequired,
  };

  HOC.defaultProps = {
    attentionBeaconProps: {
      needsAttention: false,
    },
  };

  hoistNonReactStatics(HOC, WrappedComponent);
  HOC.displayName = `withAttentionBeaconRender(${getDisplayName(WrappedComponent)})`;
  // HOC.isAttentionBeaconConsumer = true;

  return HOC;
};
